ACC.flyout = {
  flyoutMainGlobal: '.ph-flyout_main',

  showFlyout: function() {
    var numberOfProducts = parseInt($('.ph-header__minicartnumber').html(), 10);

    if ((typeof Storage !== 'undefined') && (numberOfProducts === 0)) {
      var flyoutDivShown = sessionStorage.getItem('flyoutDivShown'),
          loginDesktopVisible = $('.ph-notloggedin-tooltip').hasClass('ph-d-md-block'),
          loginMobileNotVisible = $('.ph-hamburger__wrapper').hasClass('ph-d-none');

      if ((flyoutDivShown === null || flyoutDivShown !== 'false') && (!loginDesktopVisible || loginMobileNotVisible)) {
        $(ACC.flyout.flyoutMainGlobal).removeClass('ph-flyoutonclose ph-hidden');
        setTimeout(function() {
          sessionStorage.setItem('flyoutDivShown', 'false');
          $(ACC.flyout.flyoutMainGlobal).addClass('ph-flyout_animation');

          var mobWidth = $(window).width();

          if (mobWidth < 768) {
            $(ACC.flyout.flyoutMainGlobal).css({
              width: mobWidth - 16,
              marginRight: 8
            });
          }
        }, 700);
      }
    }
  },

  closeFlyout: function() {
    $(document).on('click', '.ph-flyout_loginnow, .ph-flyout_login_mobile, .ph-flyoutClose', function() {
      $(ACC.flyout.flyoutMainGlobal).addClass('ph-flyoutonclose ph-hidden');
      ACC.introjs.bindFunction();

      if ($('.ph-page-anonymoushomepage').length > 0) {
        ACC.healthcare.introAnonymousHomePage();
      }
    });
  },

  miniCartSavings: function() {
    $(document).on('click', '.ph-arrow_minicart__click', function() {
      var isSavingsExpand = $(this).attr('aria-expanded');

      if (isSavingsExpand === 'true') {
        $('.ph-arrow_minicart__text').addClass('ph-d-none');
        $(this).attr('aria-expanded', 'false');
        $(this).find('.ph-icon-arrow-up').addClass('ph-icon-arrow-down').removeClass('ph-icon-arrow-up');
      } else {
        $('.ph-arrow_minicart__text').removeClass('ph-d-none');
        $(this).attr('aria-expanded', 'true');
        $(this).find('.ph-icon-arrow-down').removeClass('ph-icon-arrow-down').addClass('ph-icon-arrow-up');
      }
    });
  }
};


$(document).ready(function() {
  ACC.flyout.closeFlyout();
  ACC.flyout.miniCartSavings();
});
